import React, { useState, useEffect } from 'react';
import "../../css/home/groupCompanySlider.css";

const CompanySlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const logos = [
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
        "/assets/home/companies/pakgrup.png",
        "/assets/home/companies/dae.png",
        "/assets/home/companies/dt.png",
        "/assets/home/companies/aydınlatma.png",
        "/assets/home/companies/kabin.png",
        "/assets/home/companies/kanal.png",
        "/assets/home/companies/pano.png",
        "/assets/home/companies/sarj.png",
    ];

    // Sonsuz döngü için logoları üç kez tekrarlıyoruz
    const extendedLogos = [...logos, ...logos, ...logos];

    const getVisibleSlides = () => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 640) return 1;
            if (window.innerWidth < 768) return 2;
            if (window.innerWidth < 1024) return 4;
            return 6;
        }
        return 6;
    };

    const [visibleSlides, setVisibleSlides] = useState(getVisibleSlides());

    useEffect(() => {
        const handleResize = () => {
            setVisibleSlides(getVisibleSlides());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Orta kısımdan başlat
    useEffect(() => {
        setCurrentIndex(logos.length);
    }, [logos.length]);

    const nextSlide = () => {
        setCurrentIndex(prev => prev + 1);
    };

    const prevSlide = () => {
        setCurrentIndex(prev => prev - 1);
    };

    // Sonsuz döngü için pozisyon kontrolü
    useEffect(() => {
        if (currentIndex >= logos.length * 2) {
            // Sessizce orta kısma geri dön
            setTimeout(() => {
                setCurrentIndex(logos.length);
            }, 50);
        }
        if (currentIndex < logos.length) {
            // Sessizce orta kısma geri dön
            setTimeout(() => {
                setCurrentIndex(logos.length);
            }, 50);
        }
    }, [currentIndex, logos.length]);

    // Otomatik geçiş
    useEffect(() => {
        const timer = setInterval(nextSlide, 10000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="slider-wrapper">
            <h2 className="slider-title">Grup Şirketlerimiz</h2>

            <div className="slider-container">
                <button
                    onClick={prevSlide}
                    className="nav-button prev-button"
                    aria-label="Previous slide"
                >
                    &#8249;
                </button>

                <div className="slider-viewport">
                    <div
                        className="slider-track"
                        style={{
                            transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
                            transition: 'transform 0.5s ease-in-out'
                        }}
                    >
                        {extendedLogos.map((logo, index) => (
                            <div key={index} className="slide-item">
                                <div className="logo-container">
                                    <img
                                        src={logo}
                                        alt={`Company ${index + 1}`}
                                        className="company-logo"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button
                    onClick={nextSlide}
                    className="nav-button next-button"
                    aria-label="Next slide"
                >
                    &#8250;
                </button>
            </div>
        </div>
    );
};

export default CompanySlider;